import React from "react";

import heroPersonImg from "../../../assets/images/Dietplan-updated/Rs with Mobile 1 (1).png";
import heroTextureImg from "../../../assets/images/Dietplan-updated/b53acf30a7d769be963a7e4f9ac480e826207672.png";
import bgVector from "../../../assets/images/Dietplan-updated/Vector (1).png";
import sparkleIcon from "../../../assets/images/Dietplan-updated/sparkle.svg";
import targetIcon from "../../../assets/images/Dietplan-updated/Group 1116601071.png";
import signatureImg from "../../../assets/images/Dietplan-updated/b53acf30a7d769be963a7e4f9ac480e826207672.png";

import "./HeroStaticIos.css";

const HeroStaticIos = () => {
  return (
    <div className="diet-hero-static-ios-coded" aria-label="Personalized assistance hero">
      <div className="diet-hero-static-ios-coded__bg" aria-hidden="true" />

      <img
        className="diet-hero-static-ios-coded__texture"
        src={heroTextureImg}
        alt=""
        aria-hidden="true"
        loading="lazy"
      />

      <div className="diet-hero-static-ios-coded__ring" aria-hidden="true" />

      <img
        className="diet-hero-static-ios-coded__bgVector"
        src={bgVector}
        alt=""
        aria-hidden="true"
        loading="lazy"
      />

      <img
        className="diet-hero-static-ios-coded__sparkle"
        src={sparkleIcon}
        alt=""
        aria-hidden="true"
        loading="lazy"
      />

      <img
        className="diet-hero-static-ios-coded__person"
        src={heroPersonImg}
        alt=""
        loading="lazy"
        draggable="false"
      />

      <div className="diet-hero-static-ios-coded__copy">
        <div className="diet-hero-static-ios-coded__title">Personalized Assistance</div>
        <div className="diet-hero-static-ios-coded__subtitle">to successfully meet your goals.</div>
        <img
          className="diet-hero-static-ios-coded__signature"
          src={signatureImg}
          alt="Rohit Sharma signature"
          loading="lazy"
          draggable="false"
        />
      </div>

      <div className="diet-hero-static-ios-coded__bottomCard">
        <div className="diet-hero-static-ios-coded__bottomTop">
          <div className="diet-hero-static-ios-coded__brand">
            <span className="diet-hero-static-ios-coded__brandName">Dr Trust 360</span>
          </div>
          <div className="diet-hero-static-ios-coded__badge">INTELLIGENCE</div>
        </div>

        <div className="diet-hero-static-ios-coded__bottomBody">
          <span className="diet-hero-static-ios-coded__bullet" aria-hidden="true" />
          <div className="diet-hero-static-ios-coded__bodyText">
            You&apos;ve made steady progress with consistent weight loss across 2 weeks; your discipline is paying
            off—just keep going strong!
          </div>
        </div>

        <div className="diet-hero-static-ios-coded__bottomFooter" aria-hidden="true">
          <div className="diet-hero-static-ios-coded__pager">
            <span className="diet-hero-static-ios-coded__dot diet-hero-static-ios-coded__dot--active" />
            <span className="diet-hero-static-ios-coded__dot" />
            <span className="diet-hero-static-ios-coded__dot" />
          </div>

          <img className="diet-hero-static-ios-coded__target" src={targetIcon} alt="" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};

export default HeroStaticIos;

